import { NotificationType, PubSub, TopicsEnum } from "./pubsub";


type ApiErrors = Record<string, string[]>;

export const handleApiErrors = (
  errors: ApiErrors,
  setError: (name: any, error: { type: string; message: string }) => void
) => {
  if (!errors || Object.keys(errors).length === 0) return;

  
  const firstKey = Object.keys(errors)[0];
  const firstMessage = errors[firstKey][0];

  PubSub.publish(TopicsEnum.Notification.toString(), {
    message: firstMessage,
    type: NotificationType.Failure,
  });
  


  // Object.keys(errors).forEach((key) => {
  //   setError(key.charAt(0).toLowerCase() + key.slice(1), {
  //     type: "manual",
  //     message: errors[key][0],
  //   });
  // });
  // 
};
